module.exports = function getResource(label) {
    let resources = {
        yourColorIQMatch: 'Votre correspondance Color iQ.',
        edit: 'Modifier',
        colorIQ: 'Voir votre correspondance Color iQ'
    };
    return resources[label];
};
